<!-- HTML Template -->
<!-- Non-Modal Container -->
<div class="lead-management-container" *ngIf="!isModal && !leadDosNotExist">
  <ng-container *ngIf="(lead$ | async) !== null && (lead$ | async) !== undefined; else loadingTemplate">
    <ng-container *ngIf="lead$ | async as lead">
      <!-- Main Header -->
      <div class="lead-profile-main-header">
        <div class="main-header-left">
          <h1 class="editable-name-field" 
              [class.editing]="editingField === 'name'"
              [class.hovered]="hoveredField === 'name'"
              (mouseenter)="onFieldHover('name')"
              (mouseleave)="onFieldLeave('name')">
            <span class="name-display" *ngIf="editingField !== 'name'" (click)="startEdit('name', lead.fullName || '', $event)">
              {{ lead.fullName?.trim() ? lead.fullName : 'No Name Available' }}
              <mat-icon class="edit-icon" *ngIf="hoveredField === 'name'">edit</mat-icon>
            </span>
            <input *ngIf="editingField === 'name'"
                   #nameInput
                   type="text"
                   class="inline-name-input"
                   [(ngModel)]="editValue"
                   (blur)="saveEdit('name')"
                   (keyup.enter)="saveEdit('name')"
                   (keyup.escape)="cancelEdit()">
          </h1>
          <div class="name-icons">
            <mat-icon *ngIf="lead.invalid_email" style="color:red;cursor: pointer;" matTooltip="Invalid email" matTooltipPosition="above">email</mat-icon>
            <mat-icon *ngIf="lead.invalid_sms" style="color:red;cursor: pointer;" matTooltip="Invalid SMS" matTooltipPosition="above">call</mat-icon>
            <mat-icon *ngIf="!lead?.campus" style="color:red;cursor: pointer;" matTooltip="Invalid campus" matTooltipPosition="above">business</mat-icon>
            <mat-icon *ngIf="!lead?.program" style="color:red;cursor: pointer;" matTooltip="Invalid program" matTooltipPosition="above">school</mat-icon>
          </div>
        </div>
        <div class="main-header-right">
          <app-followers-button [lead]="lead"></app-followers-button>
          <app-action-page [lead]="lead" (updateOwner)="updateOwner($event)"
            (updateStopMessage)="updateStopMessage($event)"></app-action-page>

          <!-- ═══ DRAFT: Lost + Enroll ═══ -->
          <ng-container *ngIf="shouldShowDraftButtons(lead)">
            <button mat-flat-button style="color: white;background-color: red; height: 30px;" class="lost"
              (click)="LostPopUp()">Lost</button>
            <button mat-flat-button style="color: white;background-color: #1976d2; height: 30px;" class="enroll-btn"
              (click)="enrollLead()">Enroll</button>
          </ng-container>

          <!-- ═══ ENROLLED/PUSHED: Not Started + Started + Push Date ═══ -->
          <ng-container *ngIf="shouldShowEnrolledButtons(lead)">
            <button mat-flat-button style="color: white;background-color: #f44336; height: 30px;" class="not-started-btn"
              (click)="markAsNotStarted()">Not Started</button>
            <button mat-flat-button style="color: white;background-color: #4ca64f; height: 30px;" class="started-btn"
              (click)="markAsStarted()">Started</button>
            <button mat-flat-button style="color: white;background-color: #ff9800; height: 30px;" class="push-date-btn"
              (click)="pushDate()">Push Date</button>
          </ng-container>

          <!-- ═══ REOPEN (Won or Lost) ═══ -->
          <button class="reopen" *ngIf="shouldShowReopen(lead)" (click)="reOpen()">Re open</button>

          <mat-icon style="color: green; font-size: 30px; overflow: visible;" *ngIf="lead.status === 'Won'"
            matTooltip="Lead is won">sentiment_satisfied_alt</mat-icon>
          <mat-icon style="color: red; font-size: 30px; overflow: visible;" *ngIf="lead.status === 'Lost'"
            matTooltip="Lead is lost">sentiment_very_dissatisfied</mat-icon>
        </div>
      </div>

      <!-- Bottom Header -->
      <div class="lead-profile-bottom-header">
        <div class="lead-navigation-controls">
          <button mat-icon-button class="nav-button nav-prev" matTooltip="Previous Lead"
            (click)="navigateToPreviousLead()" [disabled]="!previousId || navigationLoading">
            <mat-icon *ngIf="!navigationLoading">chevron_left</mat-icon>
            <mat-spinner *ngIf="navigationLoading" diameter="20"></mat-spinner>
          </button>
          <button mat-icon-button class="nav-button nav-next" matTooltip="Next Lead"
            (click)="navigateToNextLead()" [disabled]="!nextId || navigationLoading">
            <mat-icon *ngIf="!navigationLoading">chevron_right</mat-icon>
            <mat-spinner *ngIf="navigationLoading" diameter="20"></mat-spinner>
          </button>
        </div>

        <div class="info-row">
          <div class="info-item">
            <mat-icon class="info-icon">school</mat-icon>
            <p>{{ lead.program?.name ?? 'No Program' }}</p>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">location_on</mat-icon>
            <p>{{ lead.campus?.name ?? 'No Campus' }}</p>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">calendar_today</mat-icon>
            <p>{{ lead.lead_in_date | date:'longDate' }}</p>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">person</mat-icon>
            <p>{{ lead.user?.name ?? 'Unknown' }} {{ lead.user?.lastName ?? '' }}</p>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item editable-email-field" 
               [class.editing]="editingField === 'email'"
               [class.hovered]="hoveredField === 'email'"
               (mouseenter)="onFieldHover('email')"
               (mouseleave)="onFieldLeave('email')">
            <mat-icon class="info-icon">email</mat-icon>
            <p class="email-display" *ngIf="editingField !== 'email'" (click)="startEdit('email', lead.email || '', $event)">
              {{ lead.email ?? 'No Email Provided' }}
              <mat-icon class="edit-icon" *ngIf="hoveredField === 'email'">edit</mat-icon>
            </p>
            <input *ngIf="editingField === 'email'"
                   #emailInput type="email" class="inline-email-input"
                   [(ngModel)]="editValue"
                   (blur)="saveEdit('email')" (keyup.enter)="saveEdit('email')" (keyup.escape)="cancelEdit()">
          </div>
          
          <div class="info-item editable-phone-field"
            [class.editing]="editingField === 'phone'"
            [class.hovered]="hoveredField === 'phone'"
            (mouseenter)="onFieldHover('phone')"
            (mouseleave)="onFieldLeave('phone')">
            <mat-icon class="info-icon">phone</mat-icon>
            <p class="phone-display" *ngIf="editingField !== 'phone'"
              (click)="startEdit('phone', lead.phoneNumber || '', $event)">
              {{ lead?.prefix ?? '' }} {{ lead.phoneNumber ?? 'No Phone Number' }}
              <mat-icon class="edit-icon" *ngIf="hoveredField === 'phone'">edit</mat-icon>
            </p>
            <div *ngIf="editingField === 'phone'" class="phone-edit-container" #phoneEditContainer>

              <input #prefixInput type="text" class="inline-prefix-input" [(ngModel)]="editPrefix"
                placeholder="+1" (keyup.enter)="saveEdit('phone')" (keyup.escape)="cancelEdit()">
              <input #phoneInput type="tel" class="inline-phone-input" [(ngModel)]="editPhoneNumber"
                placeholder="Phone number" (keyup.enter)="saveEdit('phone')" (keyup.escape)="cancelEdit()">
            </div>
          </div>

          <div class="phone-call-button-container" *ngIf="callsEnabled && lead.phoneNumber && lead.prefix && editingField !== 'phone'">
            <app-compact-call-button
              [phoneNumber]="(lead.prefix || '') + (lead.phoneNumber || '')"
              [leadId]="lead.id" [leadName]="lead.fullName" size="small" [showText]="true">
            </app-compact-call-button>
          </div>

          <div class="info-item">
            <mat-icon class="info-icon">account_balance</mat-icon>
            <p>{{ lead.vendorSource?.name ?? 'No Vendor Source' }}</p>
          </div>
          <div class="info-item">
            <mat-icon class="info-icon">source</mat-icon>
            <p>{{ lead.leadSource?.name ?? 'No Source' }}</p>
          </div>
        </div>
      </div>

      <!-- Duplicate warning -->
      <div class="duplicate-container" *ngIf="duplicated">
        <div class="left-dublciate">
          <mat-icon class="icon-group">group_add</mat-icon>
          <button mat-stroked-button disabled class="warning-button">Warning</button>
        </div>
        <div class="left-dublciate">
          <button mat-stroked-button (click)="openDuplicatedLeadModal()" class="resolve-button">Resolve duplicates</button>
        </div>
      </div>

      <div class="stepper-container">
        <app-stepper-purecss 
        [leadId]="lead.id" 
        [lastActivityTime]="lead.last_activity_time" 
        [isEnrolled]="lead?.enrolled_at" 
        [leadStatus]="lead.status"
        [admissionStatus]="lead.admission_status || 'draft'"
        [currentStepId]="lead.current_step_id" 
        [pipelineId]="lead.program?.pipeline_id"
        [leadTags]="lead.lead_tags"
        [enrolledAt]="lead.enrolled_at"
        [startAt]="lead.start_at"
        [isDuplicated]="lead.isDuplicated"
        [faAdvisorId]="lead.fa_advisor_id ?? null"
        (tagsChanged)="onTagsChanged($event)"
        (newStep)="newStep($event)">
      </app-stepper-purecss>
      </div>

      <div class="body-container" *ngIf="!duplicated">
        <div class="left-section">
          <app-lead-info [lead]="lead" [id]="id" (updateLead)="updateLead($event)"></app-lead-info>
        </div>
        <div #scrollableContainer class="right-section">
          @if(tabs && id){
          <app-tabs [lead]="lead" [isModal]="isModal || isEmbedded || dialogObject?.data" [resetTabs]="shouldResetTabs" [tabs]=tabs [id]="id"></app-tabs>
          }
        </div>

        <!-- <app-ai-summary [lead]="lead"></app-ai-summary> -->

      </div>

      <div class="body-container-duplicate" *ngIf="duplicated">
        <div class="left-section">
          <app-lead-info [lead]="lead" [id]="id" (updateLead)="updateLead($event)"></app-lead-info>
        </div>
        <div #scrollableContainer class="right-section">
          @if(tabs && id){
          <app-tabs [lead]="lead" [isModal]="isModal || isEmbedded || dialogObject?.data" [resetTabs]="shouldResetTabs" [tabs]=tabs [id]="id"></app-tabs>
          }
        </div>

        <!-- <app-ai-summary [lead]="lead"></app-ai-summary> -->

      </div>
    </ng-container>
  </ng-container>
</div>

<!-- ═══════════════════════════════════════════════════════ -->
<!-- MODAL CONTAINER -->
<!-- ═══════════════════════════════════════════════════════ -->
<div class="modal-lead-management-container" *ngIf="isModal && !leadDosNotExist">
  <div class="modal-outside-close-btn" (click)="closeModal()">&#10005;</div>
  
  <div class="modal-nav-arrows-container" *ngIf="dialogObject?.isLeadView">
    <button class="modal-nav-arrow modal-nav-arrow-prev" 
      (click)="navigateToPreviousLead()" [disabled]="!previousId || navigationLoading">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <button class="modal-nav-arrow modal-nav-arrow-next" 
      (click)="navigateToNextLead()" [disabled]="!nextId || navigationLoading">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="(lead$ | async) !== null && (lead$ | async) !== undefined; else loadingTemplate">
    <ng-container *ngIf="lead$ | async as lead">
      <div class="modal-lead-profile-main-header">
        <div class="modal-main-header-left">
          <h1 class="modal-editable-name-field" 
              [class.editing]="editingField === 'name'"
              [class.hovered]="hoveredField === 'name'"
              (mouseenter)="onFieldHover('name')"
              (mouseleave)="onFieldLeave('name')">
            <span class="modal-name-display" *ngIf="editingField !== 'name'" (click)="startEdit('name', lead.fullName || '', $event)">
              {{ lead.fullName?.trim() ? lead.fullName : 'No Name Available' }}
              <mat-icon class="modal-edit-icon" *ngIf="hoveredField === 'name'">edit</mat-icon>
            </span>
            <input *ngIf="editingField === 'name'"
                   #nameInput type="text" class="modal-inline-name-input"
                   [(ngModel)]="editValue"
                   (blur)="saveEdit('name')" (keyup.enter)="saveEdit('name')" (keyup.escape)="cancelEdit()">
          </h1>
          <div class="modal-name-icons">
            <mat-icon *ngIf="lead.invalid_email" style="color:red;cursor: pointer;" matTooltip="Invalid email" matTooltipPosition="above">email</mat-icon>
            <mat-icon *ngIf="lead.invalid_sms" style="color:red;cursor: pointer;" matTooltip="Invalid SMS" matTooltipPosition="above">call</mat-icon>
            <mat-icon *ngIf="!lead?.campus" style="color:red;cursor: pointer;" matTooltip="Invalid campus" matTooltipPosition="above">business</mat-icon>
            <mat-icon *ngIf="!lead?.program" style="color:red;cursor: pointer;" matTooltip="Invalid program" matTooltipPosition="above">school</mat-icon>
          </div>
        </div>
        <div class="modal-main-header-right">
          <app-followers-button [lead]="lead"></app-followers-button>
          <app-action-page [lead]="lead" (updateOwner)="updateOwner($event)"
            (updateStopMessage)="updateStopMessage($event)"></app-action-page>

          <!-- ═══ DRAFT: Lost + Enroll ═══ -->
          <ng-container *ngIf="shouldShowDraftButtons(lead)">
            <button mat-flat-button style="color: white;background-color: red; height: 30px;" class="modal-lost"
              (click)="LostPopUp()">Lost</button>
            <button mat-flat-button style="color: white;background-color: #1976d2; height: 30px;" class="modal-enroll-btn"
              (click)="enrollLead()">Enroll</button>
          </ng-container>

          <!-- ═══ ENROLLED/PUSHED: Not Started + Started + Push Date ═══ -->
          <ng-container *ngIf="shouldShowEnrolledButtons(lead)">
            <button mat-flat-button style="color: white;background-color: #f44336; height: 30px;" class="modal-not-started-btn"
              (click)="markAsNotStarted()">Not Started</button>
            <button mat-flat-button style="color: white;background-color: #4ca64f; height: 30px;" class="modal-started-btn"
              (click)="markAsStarted()">Started</button>
            <button mat-flat-button style="color: white;background-color: #ff9800; height: 30px;" class="modal-push-date-btn"
              (click)="pushDate()">Push Date</button>
          </ng-container>

          <!-- ═══ REOPEN ═══ -->
          <button class="modal-reopen" *ngIf="shouldShowReopen(lead)" (click)="reOpen()">Re open</button>

          <mat-icon style="color: green; font-size: 30px; overflow: visible;" *ngIf="lead.status === 'Won'"
            matTooltip="Lead is won">sentiment_satisfied_alt</mat-icon>
          <mat-icon style="color: red; font-size: 30px; overflow: visible;" *ngIf="lead.status === 'Lost'"
            matTooltip="Lead is lost">sentiment_very_dissatisfied</mat-icon>
        </div>
      </div>

      <div class="modal-lead-profile-bottom-header">
        <div class="modal-info-row">
          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">school</mat-icon>
            <p>{{ lead.program?.name ?? 'No Program' }}</p>
          </div>
          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">location_on</mat-icon>
            <p>{{ lead.campus?.name ?? 'No Campus' }}</p>
          </div>
          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">calendar_today</mat-icon>
            <p>{{ lead.lead_in_date | date:'longDate' }}</p>
          </div>
          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">person</mat-icon>
            <p>{{ lead.user?.name ?? 'Unknown' }} {{ lead.user?.lastName ?? '' }}</p>
          </div>
        </div>
        <div class="modal-info-row">
          <div class="modal-info-item modal-editable-email-field" 
               [class.editing]="editingField === 'email'"
               [class.hovered]="hoveredField === 'email'"
               (mouseenter)="onFieldHover('email')"
               (mouseleave)="onFieldLeave('email')">
            <mat-icon class="modal-info-icon">email</mat-icon>
            <p class="modal-email-display" *ngIf="editingField !== 'email'" (click)="startEdit('email', lead.email || '', $event)">
              {{ lead.email ?? 'No Email Provided' }}
              <mat-icon class="modal-edit-icon" *ngIf="hoveredField === 'email'">edit</mat-icon>
            </p>
            <input *ngIf="editingField === 'email'"
                   #emailInput type="email" class="modal-inline-email-input"
                   [(ngModel)]="editValue"
                   (blur)="saveEdit('email')" (keyup.enter)="saveEdit('email')" (keyup.escape)="cancelEdit()">
          </div>
          
          <div class="modal-info-item modal-editable-phone-field"
            [class.editing]="editingField === 'phone'"
            [class.hovered]="hoveredField === 'phone'"
            (mouseenter)="onFieldHover('phone')"
            (mouseleave)="onFieldLeave('phone')">
            <mat-icon class="modal-info-icon">phone</mat-icon>
            <p class="modal-phone-display" *ngIf="editingField !== 'phone'"
              (click)="startEdit('phone', lead.phoneNumber || '', $event)">
              {{ lead?.prefix ?? '' }} {{ lead.phoneNumber ?? 'No Phone Number' }}
              <mat-icon class="modal-edit-icon" *ngIf="hoveredField === 'phone'">edit</mat-icon>
            </p>
            <div *ngIf="editingField === 'phone'" class="phone-edit-container" #phoneEditContainer>

              <input #prefixInput type="text" class="modal-inline-prefix-input" [(ngModel)]="editPrefix"
                placeholder="+1" (keyup.enter)="saveEdit('phone')" (keyup.escape)="cancelEdit()">
              <input #phoneInput type="tel" class="modal-inline-phone-input" [(ngModel)]="editPhoneNumber"
                placeholder="Phone number" (keyup.enter)="saveEdit('phone')" (keyup.escape)="cancelEdit()">
            </div>
          </div>

          <div class="modal-phone-call-button-container" *ngIf="callsEnabled && lead.phoneNumber && lead.prefix && editingField !== 'phone'">
            <app-compact-call-button
              [phoneNumber]="(lead.prefix || '') + (lead.phoneNumber || '')"
              [leadId]="lead.id" [leadName]="lead.fullName" size="small" [showText]="true">
            </app-compact-call-button>
          </div>

          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">account_balance</mat-icon>
            <p>{{ lead.vendorSource?.name ?? 'No Vendor Source' }}</p>
          </div>
          <div class="modal-info-item">
            <mat-icon class="modal-info-icon">source</mat-icon>
            <p>{{ lead.leadSource?.name ?? 'No Source' }}</p>
          </div>
        </div>
      </div>

      <div class="modal-duplicate-container" *ngIf="duplicated">
        <div class="modal-left-dublciate">
          <mat-icon class="modal-icon-group">group_add</mat-icon>
          <button mat-stroked-button disabled class="modal-warning-button">Warning</button>
        </div>
        <div class="modal-left-dublciate">
          <button mat-stroked-button (click)="openDuplicatedLeadModal()" class="modal-resolve-button">Resolve duplicates</button>
        </div>
      </div>
      
      <div class="modal-stepper-container">
        <app-stepper-purecss 
        [leadId]="lead.id" 
        [lastActivityTime]="lead.last_activity_time" 
        [isEnrolled]="lead?.enrolled_at" 
        [leadStatus]="lead.status"
        [admissionStatus]="lead.admission_status || 'draft'"
        [currentStepId]="lead.current_step_id" 
        [pipelineId]="lead.program?.pipeline_id"
        [leadTags]="lead.lead_tags"
        [enrolledAt]="lead.enrolled_at"
        [startAt]="lead.start_at"
        [isDuplicated]="lead.isDuplicated"
        [faAdvisorId]="lead.fa_advisor_id ?? null"
        (tagsChanged)="onTagsChanged($event)"
        (newStep)="newStep($event)">
      </app-stepper-purecss>
      
      
      </div>

      <div class="modal-content-container" *ngIf="!duplicated">
        <div class="modal-left-section">
          <app-lead-info [lead]="lead" [id]="id" (updateLead)="updateLead($event)"></app-lead-info>
        </div>
        <div #scrollableContainer class="modal-right-section">
          @if(tabs && id){
          <app-tabs [lead]="lead" [isModal]="isModal || isEmbedded || dialogObject?.data" [resetTabs]="shouldResetTabs" [tabs]=tabs [id]="id"></app-tabs>
          }
        </div>
      </div>

      <div class="modal-content-container-duplicate" *ngIf="duplicated">
        <div class="modal-left-section">
          <app-lead-info [lead]="lead" [id]="id" (updateLead)="updateLead($event)"></app-lead-info>
        </div>
        <div #scrollableContainer class="modal-right-section">
          @if(tabs && id){
          <app-tabs [lead]="lead" [isModal]="isModal || isEmbedded || dialogObject?.data" [resetTabs]="shouldResetTabs" [tabs]=tabs [id]="id"></app-tabs>
          }
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- Loading Template -->
<ng-template #loadingTemplate>
  <app-lead-skeleton-loader></app-lead-skeleton-loader>
</ng-template>

<!-- Lead Not Found -->
<div *ngIf="leadDosNotExist" class="lead-not-found-container">
  <div class="lead-not-found-content">
    <mat-icon class="lead-not-found-icon">sentiment_very_dissatisfied</mat-icon>
    <h1 class="lead-not-found-title">Lead Not Found</h1>
    <p class="lead-not-found-message">The lead you're looking for doesn't exist or may have been removed.</p>
    <div class="lead-not-found-actions">
      <button mat-raised-button color="primary" (click)="navigateToLeads()">
        <mat-icon>list</mat-icon> View All Leads
      </button>
    </div>
  </div>
</div>